<script>
import { createWidgetMixin } from 'vue-instantsearch/vue3/es'
import { connectStats } from 'instantsearch.js/es/connectors'

export default {
  name: 'AlgoliaStatsConnector',
  mixins: [ createWidgetMixin({ connector: connectStats }) ],
  emits: ['nb-hits-change', 'page-change'],
  computed: {
    nbHits() {
      return this.state && this.state.nbHits
    },
    page() {
      return this.state && this.state.page
    },
  },
  watch: {
    nbHits() {
      this.$emit("nb-hits-change", this.nbHits)
    },
    page() {
      this.$emit("page-change")
    },
  },
  render() {
    return null
  },
}
</script>
